export const Data = {
  introduction_se: "Författaren Hussam Alkoblawi",
  body_se: `<p style="user-select: auto;">Kontakt via e-post</p><p style="user-select: auto;"><a href="mailto:hussam@nbl-bokforlag.se" style="user-select: auto;">hussam@nbl-bokforlag.se</a></p>`,
  Introduction_ar: "الكاتب حسام قبلاوي",
  body_ar: `<p style="user-select: auto;">للتواصل عبر البريد الالكتروني:</p><p style="user-select: auto;"><a href="mailto:hussam@nbl-bokforlag.se" style="user-select: auto;">hussam@nbl-bokforlag.se</a></p>`,
};
